var _circle, _circle2, _circle3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserinfoCircles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 402,
    viewBox: "0 0 295 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82.7141,
    cy: 241.11,
    r: 36.6899,
    transform: "rotate(135 82.7141 241.11)",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1.89744,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 90.2285 205.152)",
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 1.89744,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 114.379 259.357)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.698 84.8386C75.4772 137.059 75.4772 221.725 127.698 273.945C179.918 326.165 264.584 326.165 316.804 273.945C369.024 221.725 369.024 137.059 316.804 84.8386C264.584 32.6183 179.918 32.6183 127.698 84.8386ZM126.99 84.1315C74.3796 136.742 74.3796 222.041 126.99 274.652C179.601 327.263 264.9 327.263 317.511 274.652C370.122 222.041 370.122 136.742 317.511 84.1315C264.9 31.5207 179.601 31.5207 126.99 84.1315Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserinfoCircles);
export default __webpack_public_path__ + "static/media/userinfo-circles.777190fe5db9bc59835be50ff2a4f534.svg";
export { ForwardRef as ReactComponent };